import { DIALOGS } from "components/Dialogs/constants";
import { createSelector } from "reselect";
import { RootState } from "ducks/reducers";
import { getLocationQuery } from "../location/selectors";
import { DialogsState } from "./dialogs";

export const currentDialogSelector = createSelector(getLocationQuery, ({ dialog }) => dialog);
export const dialogsState = ({ dialogs }: RootState): DialogsState => dialogs;
export const currentDialogState = ({ dialogs }: RootState): DialogsState => {
  if (dialogs?.type) {
    const { child = [] } = dialogs;

    if (child?.length > 0) {
      return child[child.length - 1];
    }

    return dialogs;
  }

  return dialogs;
};
export const dialogResourcesSelector = ({ dialogs }: RootState): string[] => dialogs.resources || [];
export const dialogOptionsSelector = ({ dialogs }: RootState): Record<string, unknown> => dialogs.options || {};
export const dialogResourceSelector = createSelector(dialogResourcesSelector, resources => resources[0]);
export const dialogResourceTypeSelector = createSelector(dialogResourcesSelector, resources => resources[1]);

export const isCopyCurrentProject = createSelector(
  currentDialogSelector,
  currentDialog => currentDialog === DIALOGS.COPY_CURRENT_PROJECT,
);

export const isCopyLayerFromProject = createSelector(
  currentDialogSelector,
  currentDialog => currentDialog === DIALOGS.COPY_LAYER_FROM_PROJECT,
);
